// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__3LFDG","loader":"Loader_loader__1j2Bs"};